import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { initReactI18next, useTranslation } from 'react-i18next';
import './SkatteetatenLogo/styles.css';

import { g as getCommonClassNameDefault } from './defaults.esm.js';
import i18n from 'i18next';
import './SkatteetatenLogo/styles.css';


var logo = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cpath%20d%3D%22m0%2C40h40V0H0v40Zm20.03-12.28c-6.87%2C0-12.44-3.04-12.44-6.78s5.56-6.78%2C12.42-6.78v-3.34c1.99-.01%2C3.98.25%2C5.9.79l-5.85%2C5.93v3.41l5.86-5.99c3.9%2C1.14%2C6.56%2C3.39%2C6.56%2C5.98%2C0%2C3.75-5.57%2C6.78-12.44%2C6.78%22%20style%3D%22stroke-width%3A%200px%3B%22%2F%3E%3C%2Fsvg%3E";

var ds_buttons_en_GB = {
    "scrolltotopbutton.Title": "Back to top",
    "shared.ExternalIcon": "To another site"
};

var ds_buttons_nb_NO = {
    "scrolltotopbutton.Title": "Til toppen",
    "shared.ExternalIcon": "Til et annet nettsted"
};

var ds_buttons_nn_NO = {
    "scrolltotopbutton.Title": "Til toppen",
    "shared.ExternalIcon": "Til ein annan nettstad"
};

var ds_buttons_se_NO = {
    "scrolltotopbutton.Title": "Bajás fas",
    "shared.ExternalIcon": "Eará neahttasiidui"
};

var ds_collections_en_GB = {
    "chips.NoFilters": "No more filters",
    "chips.RemoveFilter": "Remove filter",
    "steplist.Edit": "Edit",
    "steplist.Next": "Next",
    "steplist.ResultStepIconText": "Completed"
};

var ds_collections_nb_NO = {
    "chips.NoFilters": "Ingen flere filtre",
    "chips.RemoveFilter": "Fjern filter",
    "steplist.Edit": "Endre",
    "steplist.Next": "Neste",
    "steplist.ResultStepIconText": "Fullført"
};

var ds_collections_nn_NO = {
    "chips.NoFilters": "Ingen fleire filter",
    "chips.RemoveFilter": "Fjern filter",
    "steplist.Edit": "Endre",
    "steplist.Next": "Neste",
    "steplist.ResultStepIconText": "Fullført"
};

var ds_collections_se_NO = {
    "chips.NoFilters": "Eai leat eanet filtarat",
    "chips.RemoveFilter": "Sihko filtara",
    "steplist.Edit": "Rievdat",
    "steplist.Next": "Boahtte",
    "steplist.ResultStepIconText": "Lea gárvvis"
};

var ds_forms_en_GB = {
    "datepicker.April": "April",
    "datepicker.August": "August",
    "datepicker.CalenderDisplay": "Calender display for",
    "datepicker.ChooseDate": "Choose date",
    "datepicker.December": "December",
    "datepicker.February": "February",
    "datepicker.Fri": "Fri",
    "datepicker.January": "January",
    "datepicker.July": "July",
    "datepicker.June": "June",
    "datepicker.March": "March",
    "datepicker.May": "May",
    "datepicker.Mon": "Mon",
    "datepicker.NextMonth": "Next month",
    "datepicker.November": "November",
    "datepicker.October": "October",
    "datepicker.PreviousMonth": "Previous month",
    "datepicker.Sat": "Sat",
    "datepicker.SelectMonth": "Select month",
    "datepicker.September": "September",
    "datepicker.Sun": "Sun",
    "datepicker.Thu": "Thue",
    "datepicker.Today": "Today",
    "datepicker.Tue": "Tue",
    "datepicker.TypeOrSelect": "Type or select",
    "datepicker.Wed": "Wed",
    "datepicker.Year": "Year",
    "errorsummary.Title": "To continue you must correct {{errorAmount}} error(s):",
    "fileuploader.AddMultipleLabel": "Add file(s)",
    "fileuploader.AddSingleLabel": "Add file",
    "fileuploader.DeleteConfirmation": "The file has been removed",
    "fileuploader.DeleteInProgress": "(Removing in progress)",
    "fileuploader.DeleteLabel": "Delete file",
    "fileuploader.FileFormatError": "Can not upload {{filnavn}}. Please use an accepted file format.",
    "fileuploader.FileIconLabel": "File",
    "fileuploader.FileSizeError": "We could not receive this file because it is too large. Files cannot exceed {{filstoerrelsegrense}} MB. You can try splitting the file into smaller files or using a format that takes up less space.",
    "fileuploader.FormatLabel": "Files you can upload:",
    "fileuploader.GeneralDeleteError": "Can't remove file",
    "fileuploader.GeneralUploadError": "Can't upload file",
    "fileuploader.InProgressLabel": "Upload in progress",
    "fileuploader.NoRightsToDeleteError": "You do not have permission to delete files",
    "fileuploader.NoRightsUploadError": "You do not have permission to upload files",
    "fileuploader.SuccessIconLabel": "Completed",
    "fileuploader.UploadedHeading": "Uploaded:",
    "fileuploader.UploadedSummary": "({{fileCount}} file(s) uploaded)",
    "searchfield.ButtonTitle": "Search",
    "searchfield.ClearButtonTitle": "Clear",
    "searchfield.Focus": "Use up and down to choose options when they are shown",
    "searchfield.NumberOfResults": "{{ant}} items shown."
};

var ds_forms_nb_NO = {
    "datepicker.April": "April",
    "datepicker.August": "August",
    "datepicker.CalenderDisplay": "Kalendervisning for",
    "datepicker.ChooseDate": "Velg dato",
    "datepicker.December": "Desember",
    "datepicker.February": "Februar",
    "datepicker.Fri": "Fre",
    "datepicker.January": "Januar",
    "datepicker.July": "Juli",
    "datepicker.June": "Juni",
    "datepicker.March": "Mars",
    "datepicker.May": "Mai",
    "datepicker.Mon": "Man",
    "datepicker.NextMonth": "Neste måned",
    "datepicker.November": "November",
    "datepicker.October": "Oktober",
    "datepicker.PreviousMonth": "Forrige måned",
    "datepicker.Sat": "Lør",
    "datepicker.SelectMonth": "Velg måned",
    "datepicker.September": "September",
    "datepicker.Sun": "Søn",
    "datepicker.Thu": "Tor",
    "datepicker.Today": "I dag",
    "datepicker.Tue": "Tir",
    "datepicker.TypeOrSelect": "Skriv eller velg",
    "datepicker.Wed": "Ons",
    "datepicker.Year": "Årstall",
    "errorsummary.Title": "For å gå videre må du rette opp {{errorAmount}} feil:",
    "fileuploader.AddMultipleLabel": "Legg til fil(er)",
    "fileuploader.AddSingleLabel": "Legg til fil",
    "fileuploader.DeleteConfirmation": "Filen er fjernet",
    "fileuploader.DeleteInProgress": "Fjerning pågår",
    "fileuploader.DeleteLabel": "Fjern fil",
    "fileuploader.FileFormatError": "{{filnavn}} kan ikke lastes opp. Last opp filen i riktig format.",
    "fileuploader.FileIconLabel": "Fil",
    "fileuploader.FileSizeError": "Vi kan ikke motta denne filen fordi den er for stor. Filer kan ikke overstige {{filstoerrelsegrense}} MB. Du kan forsøke å dele opp i flere mindre filer, eller bruke et format som tar mindre plass.",
    "fileuploader.FormatLabel": "Filer du kan laste opp:",
    "fileuploader.GeneralDeleteError": "Kunne ikke fjerne fil",
    "fileuploader.GeneralUploadError": "Kunne ikke laste opp fil",
    "fileuploader.InProgressLabel": "Opplasting pågår",
    "fileuploader.NoRightsToDeleteError": "Du har ikke rettigheter til å slette filer",
    "fileuploader.NoRightsUploadError": "Du har ikke rettigheter til å laste opp filer",
    "fileuploader.SuccessIconLabel": "Fullført",
    "fileuploader.UploadedHeading": "Lastet opp:",
    "fileuploader.UploadedSummary": "{{fileCount}} fil(er) lastet opp",
    "searchfield.ButtonTitle": "Søk",
    "searchfield.ClearButtonTitle": "Nullstill",
    "searchfield.Focus": "Bruk piltaster ned/opp for å velge forslag når de vises",
    "searchfield.NumberOfResults": "{{ant}} forslag vises."
};

var ds_forms_nn_NO = {
    "datepicker.April": "April",
    "datepicker.August": "August",
    "datepicker.CalenderDisplay": "Kalendervisning for",
    "datepicker.ChooseDate": "Velg dato",
    "datepicker.December": "Desember",
    "datepicker.February": "Februar",
    "datepicker.Fri": "Fr.",
    "datepicker.January": "Januar",
    "datepicker.July": "Juli",
    "datepicker.June": "Juni",
    "datepicker.March": "Mars",
    "datepicker.May": "Mai",
    "datepicker.Mon": "Ma.",
    "datepicker.NextMonth": "Neste månad",
    "datepicker.November": "November",
    "datepicker.October": "Oktober",
    "datepicker.PreviousMonth": "Førre månad",
    "datepicker.Sat": "La.",
    "datepicker.SelectMonth": "Velg månad",
    "datepicker.September": "September",
    "datepicker.Sun": "Sø.",
    "datepicker.Thu": "To.",
    "datepicker.Today": "I dag",
    "datepicker.Tue": "Ty.",
    "datepicker.TypeOrSelect": "Skriv eller velg",
    "datepicker.Wed": "On.",
    "datepicker.Year": "Årstal",
    "errorsummary.Title": "For å gå vidare må du rette opp {{errorAmount}} feil:",
    "fileuploader.AddMultipleLabel": "Legg til fil(er)",
    "fileuploader.AddSingleLabel": "Legg til fil",
    "fileuploader.DeleteConfirmation": "Fila er fjerna",
    "fileuploader.DeleteInProgress": "Fila held på å bli fjerna",
    "fileuploader.DeleteLabel": "Fjern fil",
    "fileuploader.FileFormatError": "{{filnavn}} kan ikkje bli lasta opp. Last opp fila i riktig format.",
    "fileuploader.FileIconLabel": "Fil",
    "fileuploader.FileSizeError": "Vi kan ikkje ta imot denne fila fordi den er for stor. Filer kan ikkje overstige {{filstoerrelsegrense}} MB. Du kan prøve å dele opp i fleire mindre filer, eller bruke eit format som tek mindre plass.",
    "fileuploader.FormatLabel": "Filer du kan laste opp:",
    "fileuploader.GeneralDeleteError": "Kunne ikkje fjerne fil",
    "fileuploader.GeneralUploadError": "Kunne ikkje laste opp fil",
    "fileuploader.InProgressLabel": "(Opplasting pågår)",
    "fileuploader.NoRightsToDeleteError": "Du har ikkje rett til å slette filer",
    "fileuploader.NoRightsUploadError": "Du har ikkje rett til å laste opp filer",
    "fileuploader.SuccessIconLabel": "(Fullført)",
    "fileuploader.UploadedHeading": "Lasta opp:",
    "fileuploader.UploadedSummary": "({{fileCount}} fil(er) lasta opp)",
    "searchfield.ButtonTitle": "Søk",
    "searchfield.ClearButtonTitle": "Nullstill",
    "searchfield.Focus": "Bruk piltastane ned og opp for å velje",
    "searchfield.NumberOfResults": "{{ant}} forslag blir vist."
};

var ds_forms_se_NO = {
    "datepicker.April": "Cuoŋománnu",
    "datepicker.August": "Borgemánnu",
    "datepicker.CalenderDisplay": "Kaleanddarčájeheapmi",
    "datepicker.ChooseDate": "Vállje dáhtona",
    "datepicker.December": "Juovlamánnu",
    "datepicker.February": "Guovvamánnu",
    "datepicker.Fri": "Bea",
    "datepicker.January": "Ođđajagimánnu",
    "datepicker.July": "Suoidnemánnu",
    "datepicker.June": "Geassemánnu",
    "datepicker.March": "Njukčamánnu",
    "datepicker.May": "Miessemánnu",
    "datepicker.Mon": "Mán",
    "datepicker.NextMonth": "Boahtte mánnu",
    "datepicker.November": "Skábmamánnu",
    "datepicker.October": "Golggotmánnu",
    "datepicker.PreviousMonth": "Ovddit mánnu",
    "datepicker.Sat": "Láv",
    "datepicker.SelectMonth": "Vállje mánu",
    "datepicker.September": "Čakčamánnu",
    "datepicker.Sun": "Sot",
    "datepicker.Thu": "Duo",
    "datepicker.Today": "Otne",
    "datepicker.Tue": "Dis",
    "datepicker.TypeOrSelect": "Čále dahje vállje",
    "datepicker.Wed": "Gas",
    "datepicker.Year": "Jahki",
    "errorsummary.Title": "Jus áigut viidáset de fertet divvut {{errorAmount}} boasttuvuođa:",
    "fileuploader.AddMultipleLabel": "Lasit fiilla/fiillaid",
    "fileuploader.AddSingleLabel": "Lasit fiilla",
    "fileuploader.DeleteConfirmation": "Fiila lea sihkkojuvvon",
    "fileuploader.DeleteInProgress": "(Fjerning pågår)",
    "fileuploader.DeleteLabel": "Sihko fiilla",
    "fileuploader.FileFormatError": "{{filnavn}} ii sáhte lasihuvvot. Lasit fiilla rievttes formáhtas.",
    "fileuploader.FileIconLabel": "Fiilla",
    "fileuploader.FileSizeError": "Mii eat nagot vuostáiváldit fiilla. Fiillat eai sáhte leat stuorát go {{filstoerrelsegrense}} MB. Sáhtát geahččalit juohkit fiilla eanet osiide, dahje geavahit formáhta mii geavaha unnit saji.",
    "fileuploader.FormatLabel": "Fiillaid maid sáhtát lasihit:",
    "fileuploader.GeneralDeleteError": "It sáhtán sihkkot fiilla",
    "fileuploader.GeneralUploadError": "It sáhtán lasihit fiilla",
    "fileuploader.InProgressLabel": "Viežžamin",
    "fileuploader.NoRightsToDeleteError": "Dus eai leat vuoigatvuođat sihkkot fiillaid",
    "fileuploader.NoRightsUploadError": "Dus ii leat vuoigatvuohta lasihit fiillaid",
    "fileuploader.SuccessIconLabel": "Dievasmahtton",
    "fileuploader.UploadedHeading": "Lasihuvvon:",
    "fileuploader.UploadedSummary": "({{fileCount}} filer lastet opp)",
    "searchfield.ButtonTitle": "Oza",
    "searchfield.ClearButtonTitle": "Bidjat ruovttoluotta",
    "searchfield.Focus": "Geavat vulos/bajás boaluid válljet evttohusaid",
    "searchfield.NumberOfResults": "{{ant}} evttohus/evttohusat."
};

var ds_layout_en_GB = {
    "topbanner.InkLogoImageText": "The Norwegian National Collection Agency logo",
    "topbanner.InkLogoLinkText": "Front page The Norwegian National Collection Agency",
    "topbanner.LsoLogoImageText": "Salary subsidy logo",
    "topbanner.LsoLogoLinkText": "Front page Salary subsidy",
    "topbanner.NavAriaLabel": "Theme overview",
    "topbanner.SkeLogoImageText": "The Norwegian Tax Administration logo",
    "topbanner.SkeLogoLinkText": "Front page The Norwegian Tax Administration",
    "topbanner.SkipLinkText": "Skip to main content",
    "topbannerbutton.CompanyTitle": "Logged in as company",
    "topbannerbutton.Login": "Log in",
    "topbannerbutton.Logout": "Log out",
    "topbannerbutton.Menu": "Menu",
    "topbannerbutton.Myself": "Myself",
    "topbannerbutton.MyselfTitle": "Logged in as",
    "topbannerbutton.OtherTitle": "Logged in as other"
};

var ds_layout_nb_NO = {
    "topbanner.InkLogoImageText": "Statens innkreving logo",
    "topbanner.InkLogoLinkText": "Forside Statens innkreving",
    "topbanner.LsoLogoImageText": "Lønnsstøtte",
    "topbanner.LsoLogoLinkText": "Forside Lønnsstøtte",
    "topbanner.NavAriaLabel": "Temaoversikt",
    "topbanner.SkeLogoImageText": "Skatteetaten logo",
    "topbanner.SkeLogoLinkText": "Forside Skatteetaten",
    "topbanner.SkipLinkText": "Hopp til hovedinnhold",
    "topbannerbutton.CompanyTitle": "Innlogget som virksomhet",
    "topbannerbutton.Login": "Logg inn",
    "topbannerbutton.Logout": "Logg ut",
    "topbannerbutton.Menu": "Meny",
    "topbannerbutton.Myself": "Meg selv",
    "topbannerbutton.MyselfTitle": "Innlogget som",
    "topbannerbutton.OtherTitle": "Innlogget som annen"
};

var ds_layout_nn_NO = {
    "topbanner.InkLogoImageText": "Statens innkreving logo",
    "topbanner.InkLogoLinkText": "Forside Statens innkreving",
    "topbanner.LsoLogoImageText": "Lønnsstøtte",
    "topbanner.LsoLogoLinkText": "Forside Lønnsstøtte",
    "topbanner.NavAriaLabel": "Temaoversikt",
    "topbanner.SkeLogoImageText": "Skatteetaten logo",
    "topbanner.SkeLogoLinkText": "Forside Skatteetaten",
    "topbanner.SkipLinkText": "Hopp til hovedinnhald",
    "topbannerbutton.CompanyTitle": "Innlogga som verksemd",
    "topbannerbutton.Login": "Logg inn",
    "topbannerbutton.Logout": "Logg ut",
    "topbannerbutton.Menu": "Meny",
    "topbannerbutton.Myself": "Meg sjølv",
    "topbannerbutton.MyselfTitle": "Innlogga",
    "topbannerbutton.OtherTitle": "Innlogga som annan"
};

var ds_layout_se_NO = {
    "topbanner.InkLogoImageText": "Stáhta gáibideami dovdomearka",
    "topbanner.InkLogoLinkText": "Stáhta gáibideami ovdasiidu",
    "topbanner.LsoLogoImageText": "Bálkádoarjja dovdomearka",
    "topbanner.LsoLogoLinkText": "Bálkádoarjja ovdasiidu",
    "topbanner.NavAriaLabel": "Fáddábajilgovva",
    "topbanner.SkeLogoImageText": "Vearroetáhta dovdomearka",
    "topbanner.SkeLogoLinkText": "Vearroetáhta ovdasiidu",
    "topbanner.SkipLinkText": "Váldosisdollui",
    "topbannerbutton.CompanyTitle": "Sisačálihuvvon dego fitnodat",
    "topbannerbutton.Login": "Sisačáliheapmi",
    "topbannerbutton.Logout": "Čálit ologgos",
    "topbannerbutton.Menu": "Fállu",
    "topbannerbutton.Myself": "Mun ieš",
    "topbannerbutton.MyselfTitle": "Guoskevaš",
    "topbannerbutton.OtherTitle": "Sisačálihuvvon dego"
};

var ds_navigation_en_GB = {
    "breadcrumbs.ExpandAltText": "Show full path",
    "breadcrumbs.NavAriaLabel": "You are here:",
    "pagination.EllipsisAltText": "Dot, dot, dot",
    "pagination.NextButtonTitle": "Next",
    "pagination.PageSummary": "Shows {{range}} of {{total}}",
    "pagination.PreviousButtonTitle": "Previous",
    "pagination.WrapperAriaLabel": "Page navigation"
};

var ds_navigation_nb_NO = {
    "breadcrumbs.ExpandAltText": "Vis hele stien",
    "breadcrumbs.NavAriaLabel": "Du er her:",
    "pagination.EllipsisAltText": "Prikk, prikk, prikk",
    "pagination.NextButtonTitle": "Neste",
    "pagination.PageSummary": "Viser {{range}} av {{total}}",
    "pagination.PreviousButtonTitle": "Forrige",
    "pagination.WrapperAriaLabel": "Sidevelger"
};

var ds_navigation_nn_NO = {
    "breadcrumbs.ExpandAltText": "Vis heile stien",
    "breadcrumbs.NavAriaLabel": "Du er her:",
    "pagination.EllipsisAltText": "Prikk, prikk, prikk",
    "pagination.NextButtonTitle": "Neste",
    "pagination.PageSummary": "Viser {{range}} av {{total}}",
    "pagination.PreviousButtonTitle": "Førre",
    "pagination.WrapperAriaLabel": "Sideveljar"
};

var ds_navigation_se_NO = {
    "breadcrumbs.ExpandAltText": "Čájet olles bálgá",
    "breadcrumbs.NavAriaLabel": "Don leat dás:",
    "pagination.EllipsisAltText": "Čuokkis, čuokkis, čuokkis",
    "pagination.NextButtonTitle": "Boahtte",
    "pagination.PageSummary": "Čájeha {{range}} oktiibuot {{total}} bohtosis",
    "pagination.PreviousButtonTitle": "Ovddit",
    "pagination.WrapperAriaLabel": "Siidonavigašuvdna"
};

var ds_overlays_en_GB = {
    "modal.CloseModal": "Close dialogue window",
    "modal.StayLoggedIn": "Yes, stay logged in",
    "modal.WaitNoticeImageAltText": "Illustration of a busy person with six arms, occupied with office work.",
    "modal.WaitNoticeParagraph": "You have been inactive for a while, are you still here?",
    "modal.WaitNoticeTitle": "Hello, are you still here?",
    "rolepicker.And": "and",
    "rolepicker.Business": "enterprise",
    "rolepicker.BusinessDescriptionPrefix": "Org. no",
    "rolepicker.Businesses": "enterprises",
    "rolepicker.BusinessesHeading": "Enterprises",
    "rolepicker.BusinessHits": "matches in enterprises",
    "rolepicker.Cancel": "Cancel",
    "rolepicker.Deceased": "Deceased",
    "rolepicker.Deleted": "Discontinued",
    "rolepicker.GoToMyPage": "Go to My page",
    "rolepicker.Heading": "Who do you wish to represent?",
    "rolepicker.InactiveBusinessPostfix": "(Discontinued)",
    "rolepicker.Logout": "Log out",
    "rolepicker.MainBusiness": "Main unit",
    "rolepicker.MeHeading": "Myself",
    "rolepicker.NoBusinessesDescription": "To use the form, you must represent a",
    "rolepicker.NoBusinessesErrorTitle": "You cannot use this form",
    "rolepicker.People": "persons",
    "rolepicker.PeopleDescriptionPrefix": "Birth/D-number",
    "rolepicker.PeopleHeading": "Others persons",
    "rolepicker.PeopleHits": "matches in other persons",
    "rolepicker.Person": "person",
    "rolepicker.SearchAll": "Search for the person’s name or birth number, the enterprise’s name or organization number.",
    "rolepicker.SearchBusinesses": "Search for the enterprise’s name or organization number.",
    "rolepicker.SearchPeople": "Search for the person’s name or birth number.",
    "rolepicker.SearchPlaceholder": "Search for person/enterprise",
    "rolepicker.SearchResultDescription": "Search results are updated continuously as you type",
    "rolepicker.SearchResultUpdated": "Search result is updated",
    "rolepicker.ShowAll": "Show all",
    "rolepicker.ShowDeceasedPersons": "Show deceased",
    "rolepicker.ShowInactiveBusinessesHeader": "Show discontinued enterprises",
    "rolepicker.ShowSubBusinessesHeading": "Show subunits",
    "rolepicker.SubUnit": "Subunit",
    "rolepicker.YouCanRepresent": "You can represent"
};

var ds_overlays_nb_NO = {
    "modal.CloseModal": "Lukk dialogvindu",
    "modal.StayLoggedIn": "Ja, forbli innlogget",
    "modal.WaitNoticeImageAltText": "Illustrasjon av travel person med seks armer, opptatt med kontorarbeid.",
    "modal.WaitNoticeParagraph": "Vi ser at du ikke har gjort noe på nettsiden på ei stund. Er du fortsatt her?",
    "modal.WaitNoticeTitle": "Hei, er du fortsatt her?",
    "rolepicker.And": "og",
    "rolepicker.Business": "virksomhet",
    "rolepicker.BusinessDescriptionPrefix": "Org. nr:",
    "rolepicker.Businesses": "virksomheter",
    "rolepicker.BusinessesHeading": "Virksomheter",
    "rolepicker.BusinessHits": "treff i virksomheter",
    "rolepicker.Cancel": "Avbryt",
    "rolepicker.Deceased": "Avdød",
    "rolepicker.Deleted": "Avviklet",
    "rolepicker.GoToMyPage": "Gå til Min side",
    "rolepicker.Heading": "Hvem ønsker du å representere?",
    "rolepicker.InactiveBusinessPostfix": "(Avviklet)",
    "rolepicker.Logout": "Logg ut",
    "rolepicker.MainBusiness": "Hovedenhet",
    "rolepicker.MeHeading": "Meg selv",
    "rolepicker.NoBusinessesDescription": "For å bruke skjemaet må du representere en",
    "rolepicker.NoBusinessesErrorTitle": "Du kan ikke bruke dette skjemaet",
    "rolepicker.People": "personer",
    "rolepicker.PeopleDescriptionPrefix": "Fødsels-/D-nummer",
    "rolepicker.PeopleHeading": "Andre personer",
    "rolepicker.PeopleHits": "treff i andre personer",
    "rolepicker.Person": "person",
    "rolepicker.SearchAll": "Søk etter personens navn eller fødselsnummer, virksomhetens navn eller organisasjonsnummer.",
    "rolepicker.SearchBusinesses": "Søk etter virksomhetens navn eller organisasjonsnummer.",
    "rolepicker.SearchPeople": "Søk etter personens navn eller fødselsnummer.",
    "rolepicker.SearchPlaceholder": "Søk etter person/virksomhet",
    "rolepicker.SearchResultDescription": "Søketreff oppdateres fortløpende mens du skriver",
    "rolepicker.SearchResultUpdated": "Søkeresultat er oppdatert",
    "rolepicker.ShowAll": "Vis alle",
    "rolepicker.ShowDeceasedPersons": "Vis avdøde",
    "rolepicker.ShowInactiveBusinessesHeader": "Vis avviklede virksomheter",
    "rolepicker.ShowSubBusinessesHeading": "Vis underenheter",
    "rolepicker.SubUnit": "Underenhet",
    "rolepicker.YouCanRepresent": "Du kan representere"
};

var ds_overlays_nn_NO = {
    "modal.CloseModal": "Lukk dialogvindauge",
    "modal.StayLoggedIn": "Ja, forbli innlogga",
    "modal.WaitNoticeImageAltText": "Illustrasjon av travel person med seks armar, oppteken med kontorarbeid.",
    "modal.WaitNoticeParagraph": "Vi ser at du ikkje har gjort noko på nettsida på ei stund. Er du framleis her?",
    "modal.WaitNoticeTitle": "Hei, er du framleis her?",
    "rolepicker.And": "og",
    "rolepicker.Business": "verksemd",
    "rolepicker.BusinessDescriptionPrefix": "Org. nr:",
    "rolepicker.Businesses": "verksemder",
    "rolepicker.BusinessesHeading": "Verksemder",
    "rolepicker.BusinessHits": "treff i verksemder",
    "rolepicker.Cancel": "Avbryt",
    "rolepicker.Deceased": "(Avdød)",
    "rolepicker.Deleted": "Avvikla",
    "rolepicker.GoToMyPage": "Gå til Mi side",
    "rolepicker.Heading": "Kven ønsker du å representere?",
    "rolepicker.InactiveBusinessPostfix": "(Avvikla)",
    "rolepicker.Logout": "Logg ut",
    "rolepicker.MainBusiness": "Hovudeining",
    "rolepicker.MeHeading": "Meg sjølv",
    "rolepicker.NoBusinessesDescription": "For å bruke skjemaet må du representere ei",
    "rolepicker.NoBusinessesErrorTitle": "Du kan ikkje bruke dette skjemaet",
    "rolepicker.People": "personar",
    "rolepicker.PeopleDescriptionPrefix": "Fødsels-/D-nummer",
    "rolepicker.PeopleHeading": "Andre personar",
    "rolepicker.PeopleHits": "treff i andre personar",
    "rolepicker.Person": "person",
    "rolepicker.SearchAll": "Søk etter personens navn eller fødselsnummer, namnet på verksemda eller organisasjonsnummer.",
    "rolepicker.SearchBusinesses": "Søk etter namn på verksemda eller organisasjonsnummer.",
    "rolepicker.SearchPeople": "Søk etter personens namn eller fødselsnummer.",
    "rolepicker.SearchPlaceholder": "Søk etter person/verksemd",
    "rolepicker.SearchResultDescription": "Søketreff blir oppdaterte fortløpande medan du skriv",
    "rolepicker.SearchResultUpdated": "Søkeresultat er oppdatert",
    "rolepicker.ShowAll": "Vis alle",
    "rolepicker.ShowDeceasedPersons": "(Vis avdøde)",
    "rolepicker.ShowInactiveBusinessesHeader": "Vis avvikla verksemder",
    "rolepicker.ShowSubBusinessesHeading": "Vis undereiningar",
    "rolepicker.SubUnit": "Undereining",
    "rolepicker.YouCanRepresent": "Du kan representere"
};

var ds_overlays_se_NO = {
    "modal.CloseModal": "Govčča dialogagieddi",
    "modal.StayLoggedIn": "\tJo, ále čálit olggos",
    "modal.WaitNoticeImageAltText": "Illustrašuvdna persovnnas geas leat guhtta gieđa ja lea ovttaskas kantuvradoaimmain.",
    "modal.WaitNoticeParagraph": "Mii oaidnit ahte don it leat rievdadan maidege guhkes áigái. Leat go ain dás?",
    "modal.WaitNoticeTitle": "\tBuorre beaivi, leat go ain dás?",
    "rolepicker.And": "\tja",
    "rolepicker.Business": "\tdoaibma",
    "rolepicker.BusinessDescriptionPrefix": "\tOrg. nr:",
    "rolepicker.Businesses": "doaimmat",
    "rolepicker.BusinessesHeading": "\tDoaimmat",
    "rolepicker.BusinessHits": "ohcanboađus doaimmaiguin",
    "rolepicker.Cancel": "Botke",
    "rolepicker.Deceased": "(Avdød)",
    "rolepicker.Deleted": "\tHeaittihuvvon",
    "rolepicker.GoToMyPage": "\tVuolgge Mu siidui",
    "rolepicker.Heading": "\tGean áiggut ovddastit?",
    "rolepicker.InactiveBusinessPostfix": "\t(Heaittihuvvon)",
    "rolepicker.Logout": "Čálit olggos",
    "rolepicker.MainBusiness": "Váldodoaibma",
    "rolepicker.MeHeading": "\tMu",
    "rolepicker.NoBusinessesDescription": "Jus áiggut geavahit skovi de fertet ovddastit gean nu",
    "rolepicker.NoBusinessesErrorTitle": "\tDon it sáhte geavahit skovi",
    "rolepicker.People": "\tpersovnnat",
    "rolepicker.PeopleDescriptionPrefix": "Riegádan-/D-nummar",
    "rolepicker.PeopleHeading": "\tEará olbmot",
    "rolepicker.PeopleHits": "ohcanboađus eará olbmuiguin",
    "rolepicker.Person": "persovdna",
    "rolepicker.SearchAll": "Oza persovnna nama dahje riegádannummara, doaimma nama dahje organisašuvdnanummara.",
    "rolepicker.SearchBusinesses": "Oza doaimma náma dahje organisašuvdnanummara.",
    "rolepicker.SearchPeople": "\tOza persovnna nama dahje riegádannummara.",
    "rolepicker.SearchPlaceholder": "\tOza olmmo/doaimma",
    "rolepicker.SearchResultDescription": "\tOhcanboahtu ođasmahttojuvvo čáledettiin",
    "rolepicker.SearchResultUpdated": "\tOhcanboahtu lea ođasmahttojuvvon",
    "rolepicker.ShowAll": "\tČájet buohkaid",
    "rolepicker.ShowDeceasedPersons": "(Vis avdøde)",
    "rolepicker.ShowInactiveBusinessesHeader": "\tČájet heaittihuvvon doaimmaid",
    "rolepicker.ShowSubBusinessesHeading": "\tČájet vuolleovttadagaid",
    "rolepicker.SubUnit": "\tVuolleovttadat",
    "rolepicker.YouCanRepresent": "\tDon sáhtát ovddastit"
};

var ds_progress_en_GB = {
    "spinner.LoadingLabel": "Loading"
};

var ds_progress_nb_NO = {
    "spinner.LoadingLabel": "Laster inn"
};

var ds_progress_nn_NO = {
    "spinner.LoadingLabel": "Lastar inn"
};

var ds_progress_se_NO = {
    "spinner.LoadingLabel": "Bargamin"
};

var ds_status_en_GB = {
    "alert.CloseMessage": "Close message"
};

var ds_status_nb_NO = {
    "alert.CloseMessage": "Lukk melding"
};

var ds_status_nn_NO = {
    "alert.CloseMessage": "Lukk melding"
};

var ds_status_se_NO = {
    "alert.CloseMessage": "Govčča"
};

var ds_tables_en_GB = {
    "pagination.Back": "Back",
    "pagination.Forward": "Forward",
    "pagination.Title": "Shows {view} of {total}",
    "table.ExpandAreaEnd": "End of expanded content.",
    "table.ExpandAreaStart": "Beginning of expanded content.",
    "table.NotSorted": "Not sorted",
    "table.Sortable": "Sortable",
    "table.SortedAscending": "Sorted ascending",
    "table.SortedDescending": "Sorted descending",
    "tablerow.Editable": "Edit row",
    "tablerow.EditData": "Edit data",
    "tablerow.Expandable": "More information",
    "tablesum.Sum": "Sum"
};

var ds_tables_nb_NO = {
    "pagination.Back": "Tilbake",
    "pagination.Forward": "Frem",
    "pagination.Title": "Viser {view} av {total}",
    "table.ExpandAreaEnd": "Slutt på utvidet innhold.",
    "table.ExpandAreaStart": "Start på utvidet innhold.",
    "table.NotSorted": "Ikke sortert",
    "table.Sortable": "Sorterbar",
    "table.SortedAscending": "Sortert stigende",
    "table.SortedDescending": "Sortert synkende",
    "tablerow.Editable": "Rediger rad",
    "tablerow.EditData": "Rediger data",
    "tablerow.Expandable": "Mer informasjon",
    "tablesum.Sum": "Sum"
};

var ds_tables_nn_NO = {
    "pagination.Back": "Tilbake",
    "pagination.Forward": "Fram",
    "pagination.Title": "Viser {view} av {total}",
    "table.ExpandAreaEnd": "Slutt på utvida innhald.",
    "table.ExpandAreaStart": "Start på utvida innhald.",
    "table.NotSorted": "Ikkje sortert",
    "table.Sortable": "Sorterbar",
    "table.SortedAscending": "Sortert stigande",
    "table.SortedDescending": "Sortert synkande",
    "tablerow.Editable": "Rediger rad",
    "tablerow.EditData": "Rediger data",
    "tablerow.Expandable": "Meir informasjon",
    "tablesum.Sum": "Sum"
};

var ds_tables_se_NO = {
    "pagination.Back": "Ruovttuluotta",
    "pagination.Forward": "Ovddas",
    "pagination.Title": "Čájeha {view} oktiibuot {total} bohtosis",
    "table.ExpandAreaEnd": "Viiddiduvvon sisdoalu loahppa",
    "table.ExpandAreaStart": "Viiddiduvvon sisdoalu álgu",
    "table.NotSorted": "Ii leat sirrejuvvon",
    "table.Sortable": "Vejolaš sirret",
    "table.SortedAscending": "Sirrejuvvon lassáneamen",
    "table.SortedDescending": "Sirrejuvvon vuolideamen",
    "tablerow.Editable": "Redigere ráiddu",
    "tablerow.EditData": "Redigere dieđuid",
    "tablerow.Expandable": "Eanet dieđut",
    "tablesum.Sum": "Submi"
};

var Shared_en_GB = {
    "shared.AccessibilityStatement": "Accessibility statement",
    "shared.AccessibilityStatementURL": "https://uustatus.no/",
    "shared.ChooseValue": "Select",
    "shared.Close": "Close",
    "shared.ContactUs": "Contact us",
    "shared.ContactUsURL": "https://www.skatteetaten.no/en/contact/",
    "shared.Help": "Help",
    "shared.RequiredField": "Mandatory field",
    "shared.SecurityAndPrivacy": "Security and privacy",
    "shared.SecurityAndPrivacyURL": "https://www.skatteetaten.no/en/about-the-tax-administration/security-and-privacy/",
    "shared.SkeLogoImageText": "The Norwegian Tax Administration logo",
    "shared.Yes": "Yes"
};

var Shared_nb_NO = {
    "shared.AccessibilityStatement": "Tilgjengelighetserklæring",
    "shared.AccessibilityStatementURL": "https://uustatus.no/",
    "shared.ChooseValue": "Velg",
    "shared.Close": "Lukk",
    "shared.ContactUs": "Kontakt oss",
    "shared.ContactUsURL": "https://www.skatteetaten.no/kontakt/",
    "shared.Help": "Hjelp",
    "shared.RequiredField": "Må fylles ut ",
    "shared.SecurityAndPrivacy": "Sikkerhet og personvern",
    "shared.SecurityAndPrivacyURL": "https://www.skatteetaten.no/om-skatteetaten/sikkerhet/",
    "shared.SkeLogoImageText": "Skatteetaten logo",
    "shared.Yes": "Ja"
};

var Shared_nn_NO = {
    "shared.AccessibilityStatement": "Tilgjengelegheitserklæring",
    "shared.AccessibilityStatementURL": "https://uustatus.no/",
    "shared.ChooseValue": "Vel",
    "shared.Close": "Lukk",
    "shared.ContactUs": "Kontakt oss",
    "shared.ContactUsURL": "https://www.skatteetaten.no/nn/kontakt-oss/",
    "shared.Help": "Hjelp",
    "shared.RequiredField": "Må fyllast ut  ",
    "shared.SecurityAndPrivacy": "Sikkerheit og personvern",
    "shared.SecurityAndPrivacyURL": "https://www.skatteetaten.no/nn/om-skatteetaten/tryggleik-og-personvern/",
    "shared.SkeLogoImageText": "Skatteetaten logo",
    "shared.Yes": "Ja"
};

var Shared_se_NO = {
    "shared.AccessibilityStatement": "Almmusjulggaštus",
    "shared.AccessibilityStatementURL": "https://uustatus.no/",
    "shared.ChooseValue": "Vállje",
    "shared.Close": "Govčča",
    "shared.ContactUs": "Válde oktavuođa minguin",
    "shared.ContactUsURL": "https://www.skatteetaten.no/kontakt/",
    "shared.Help": "Veahkki",
    "shared.RequiredField": "Fertet deavddit",
    "shared.SecurityAndPrivacy": "Sihkarvuohta ja persovdnasuodjaleapmi",
    "shared.SecurityAndPrivacyURL": "https://www.skatteetaten.no/om-skatteetaten/sikkerhet/",
    "shared.SkeLogoImageText": "Vearroetáhta dovdomearka"
};

var Languages = /*#__PURE__*/ function(Languages) {
    Languages["Bokmal"] = "nb_NO";
    Languages["Nynorsk"] = "nn_NO";
    Languages["Engelsk"] = "en_GB";
    Languages["Samisk"] = "se_NO";
    return Languages;
}({});
const langToLocale = {
    nb: "nb_NO",
    nn: "nn_NO",
    en: "en_GB",
    se: "se_NO"
};
const resources = {
    en_GB: {
        Shared: Shared_en_GB,
        ds_buttons: ds_buttons_en_GB,
        ds_collections: ds_collections_en_GB,
        ds_forms: ds_forms_en_GB,
        ds_layout: ds_layout_en_GB,
        ds_navigation: ds_navigation_en_GB,
        ds_overlays: ds_overlays_en_GB,
        ds_progress: ds_progress_en_GB,
        ds_status: ds_status_en_GB,
        ds_tables: ds_tables_en_GB
    },
    nb_NO: {
        Shared: Shared_nb_NO,
        ds_buttons: ds_buttons_nb_NO,
        ds_collections: ds_collections_nb_NO,
        ds_forms: ds_forms_nb_NO,
        ds_layout: ds_layout_nb_NO,
        ds_navigation: ds_navigation_nb_NO,
        ds_overlays: ds_overlays_nb_NO,
        ds_progress: ds_progress_nb_NO,
        ds_status: ds_status_nb_NO,
        ds_tables: ds_tables_nb_NO
    },
    nn_NO: {
        Shared: Shared_nn_NO,
        ds_buttons: ds_buttons_nn_NO,
        ds_collections: ds_collections_nn_NO,
        ds_forms: ds_forms_nn_NO,
        ds_layout: ds_layout_nn_NO,
        ds_navigation: ds_navigation_nn_NO,
        ds_overlays: ds_overlays_nn_NO,
        ds_progress: ds_progress_nn_NO,
        ds_status: ds_status_nn_NO,
        ds_tables: ds_tables_nn_NO
    },
    se_NO: {
        Shared: Shared_se_NO,
        ds_buttons: ds_buttons_se_NO,
        ds_collections: ds_collections_se_NO,
        ds_forms: ds_forms_se_NO,
        ds_layout: ds_layout_se_NO,
        ds_navigation: ds_navigation_se_NO,
        ds_overlays: ds_overlays_se_NO,
        ds_progress: ds_progress_se_NO,
        ds_status: ds_status_se_NO,
        ds_tables: ds_tables_se_NO
    }
};
const dsI18n = i18n.createInstance({
    keySeparator: false,
    nsSeparator: ':',
    fallbackLng: 'nb_NO',
    react: {
        useSuspense: false
    },
    lng: "nb_NO",
    parseMissingKeyHandler: (_key)=>'',
    debug: false,
    interpolation: {
        escapeValue: false
    },
    resources
});
dsI18n.use(initReactI18next).init();

var styles = {
    "logo": "SkatteetatenLogo-module_logo__aH-6H"
};

const SkatteetatenLogo = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId }, ref)=>{
    const { t } = useTranslation('Shared', {
        i18n: dsI18n
    });
    return /*#__PURE__*/ jsx("img", {
        ref: ref,
        id: id,
        className: `${styles.logo} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        src: logo,
        alt: t('shared.SkeLogoImageText')
    });
});
SkatteetatenLogo.displayName = 'SkatteetatenLogo';

export { Languages as L, SkatteetatenLogo as S, dsI18n as d, langToLocale as l, resources as r };
